import React, { Suspense, lazy } from 'react';
// import './App.css';

import './styles/app-sheet-loader.scss'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { TraslatorHelper as tLang } from './lib/utils'
import isMobileOrTablet from './lib/detectmobilebrowsers';
import routes from './config/routes';

import GlobalNav from './components/navigation/GlobalNav.jsx';
import SiteFooter from './components/navigation/SiteFooter';

import { appState } from './lib/appConfig'


// Home Component
const Home = lazy(() => import("./components/home/HomePage"));
// Posts Component
const ListPosts = lazy(() => import("./components/post/ListPosts"));
const ViewPost = lazy(() => import("./components/post/ViewPost"));
// Downloads Components
const Mods = lazy(() => import("./components/download/Mods"));
const Software = lazy(() => import("./components/download/Software"));
// Videos Component
const ListVideos = lazy(() => import("./components/video/ListVideos"));
// Static Site Web Pages
const AboutContact = lazy(() => import("./components/site/ContactAndInfo"));
const SiteMap = lazy(() => import("./components/site/SiteMap"));
const PrivacyPolicy = lazy(() => import("./components/site/PrivacyPolicy"));
// Maintenance Dummy Page
const Maintenance = lazy(() => import('./components/maintenance'));
// Disabled Components
// const ReportAnIssue = lazy(() => import('./components/site/ReportAnIssue'));
// const CancelSub = lazy(() => import("./components/site/CancelSub"));

function App() {
  const applicationView = isMobileOrTablet() ? 'app-mobile-view' : 'app-desktop-view';

  const postsSections = [
    {paths: routes.posts, category: 'post'},
    {paths: routes.news, category: 'news'},
    {paths: routes.tutorials, category: 'tutorial'}
  ];

  const postCategoryRoutes = postsSections.map((item, index) => {
    const routeSections = [
      <Route
        key={`post-list-section-${index}`}
        path={item.paths.paginate}
        render={(props) => (
          <ListPosts
            {...props}
            tLang={tLang}
            viewPostRoute={item.paths.unit}
            postCategory={item.category}
          />
      )}/>,
      <Route
        key={`post-view-section-${index}`}
        path={item.paths.view}
        render={(props) => (
          <ViewPost {...props} tLang={tLang} postCategory={item.category}/>
      )}/>
    ]

    return routeSections;
  });

  return (

    <Router>
      <div className={`app-wrapper ${applicationView}`}>
        <GlobalNav tLang={tLang} routes={routes}/>
        <Suspense fallback={<div>Loading...</div>}>    
          <Switch>
            { !appState.isUnderMaintenance
              ? <>
                  {/* Solution for Passing Props to Home Page on: https://stackoverflow.com/a/38907715 */}
                  <Route exact path={routes.home} component={() => <Home tLang={tLang} postsSections={postsSections}/>} />
                  <Route path={routes.contactInfo} component={() => <AboutContact tLang={tLang}/>} />
                  <Route path={routes.sitemap} component={() => <SiteMap tLang={tLang} routes={routes}/>} />
                  <Route path={routes.privacypolicy} component={PrivacyPolicy} />

                  {/* Posts Routes */}
                  { postCategoryRoutes.flat() }

                  {/* Download Routes */}
                  <Route
                    path={routes.modsPaginate}
                    render={(props) => (
                      <Mods {...props} tLang={tLang} />
                    )}
                  />

                  <Route
                    path={routes.softwarePaginate}
                    render={(props) => (
                      <Software {...props} tLang={tLang} />
                    )}
                  />

                  <Route path={routes.videos} component={() => <ListVideos tLang={tLang}/>}/>

                  {/* TODO OR NOTE: /cancel-subscription disabled until further notice */}
                  {/* <Route path={routes.cancelSubs} render={(props) => <CancelSub {...props} tLang={tLang}/>} /> */}
                  {/* TODO OR NOTE: /send-feedback disabled until further notice */}
                  {/* <Route path={routes.report} render={(props) => <ReportAnIssue {...props} tLang={tLang}/>} /> */}
                </>
              : <Route path='*' component={() => <Maintenance t={tLang}/>}/>
            }
          </Switch>
        </Suspense>
        <SiteFooter t={tLang} routes={routes}/>
      </div>
    </Router>
  );
}

export default App;
